import React, { Component } from 'react';
import Link, { navigateTo } from 'gatsby-link';
import {
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import SolarPowerLogo from '../../img/SolarPower.png';

const HOME_DIR = 'https://www.solar-power.cl';

class Header extends Component {
  state = { isOpen: false };
  toggle = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  renderCatalogButton = () => (
    <NavItem className="g-mx-10--lg g-mx-15--xl">
      <a href={`${HOME_DIR}/catalogo`} className="nav-link">
        Catálogo
      </a>
    </NavItem>
  );

  render() {
    return (
      <header
        id="js-header"
        className="u-header u-header--sticky-top u-header--toggle-section u-header--change-appearance u-shadow-v19 d-print-none"
      >
        <div className="u-header__section u-header__section--light g-bg-white g-transition-0_3 g-py-10">
          <Navbar expand="md" className="js-mega-menu hs-menu-initialized hs-menu-horizontal">
            <NavbarBrand href="https://www.solar-power.cl/">
              <img
                src={SolarPowerLogo}
                style={{ margin: 0, padding: 0, width: '250px' }}
                alt="Solar-Power Logo"
              />
              {/* <span
                className="g-line-height-1 g-brd-none g-pa-0"
                style={{ fontSize: '1rem', fontWeight: 700 }}
              >
                Consumo
              </span> */}
            </NavbarBrand>
            <NavbarToggler
              onClick={this.toggle}
              className="navbar-toggler-right btn g-line-height-1 g-brd-none g-pa-0 g-pos-abs g-top-3 g-right-0"
              style={{ margin: '1.5rem' }}
            >
              <span className="hamburger hamburger--slider">
                <span className="hamburger-box">
                  <span className="hamburger-inner" />
                </span>
              </span>
            </NavbarToggler>
            <Collapse
              isOpen={this.state.isOpen}
              navbar
              className="align-items-center flex-sm-row g-pt-10 g-pt-5--lg g-mr-40--lg"
            >
              <Nav
                className="ml-auto"
                navbar
                className="text-uppercase g-pos-rel g-font-weight-600 ml-auto"
              >
                <NavItem className="g-mx-10--lg g-mx-15--xl">
                  <a href="https://www.solar-power.cl/" className="nav-link">
                    Inicio
                  </a>
                </NavItem>
                {this.renderCatalogButton()}
                <NavItem className="g-mx-10--lg g-mx-15--xl">
                  <a href={`${HOME_DIR}/contacto`} className="nav-link">
                    Contacto
                  </a>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js